import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SectionEmpresasComponent } from './component/section-empresas/section-empresas.component';
import { SectionPilaresComponent } from './component/section-pilares/section-pilares.component';
import { FooterComponent } from './page-layout/footer/footer.component';
import { PageLayoutComponent } from './page-layout/page-layout.component';
import { TopNavComponent } from './page-layout/top-nav/top-nav.component';
import { PageApoioCulturalComponent } from './views/page-apoio-cultural/page-apoio-cultural.component';
import { SectionTituloApoioCulturalComponent } from './views/page-apoio-cultural/section-titulo-apoio-cultural/section-titulo-apoio-cultural.component';
import { PageAtuacaoComponent } from './views/page-atuacao/page-atuacao.component';
import { SectionFocosAtuacaoComponent } from './views/page-atuacao/section-focos-atuacao/section-focos-atuacao.component';
import { SectionTituloAtuacaoComponent } from './views/page-atuacao/section-titulo-atuacao/section-titulo-atuacao.component';
import { PageComoIncubarSuaEmpresaComponent } from './views/page-como-incubar-sua-empresa/page-como-incubar-sua-empresa.component';
import { SectionIncubeSuaEmpresaComponent } from './views/page-como-incubar-sua-empresa/section-incube-sua-empresa/section-incube-sua-empresa.component';
import { PageContatoComponent } from './views/page-contato/page-contato.component';
import { SectionFaleConoscoComponent } from './views/page-contato/section-fale-conosco/section-fale-conosco.component';
import { SectionMapaComponent } from './views/page-contato/section-mapa/section-mapa.component';
import { PageCulturaColaborativaComponent } from './views/page-cultura-colaborativa/page-cultura-colaborativa.component';
import { SectionDescricaoCulturaColaborativaComponent } from './views/page-cultura-colaborativa/section-descricao-cultura-colaborativa/section-descricao-cultura-colaborativa.component';
import { SectionRedeColaboradoresComponent } from './views/page-cultura-colaborativa/section-rede-colaboradores/section-rede-colaboradores.component';
import { SectionServicosECursosComponent } from './views/page-cultura-colaborativa/section-servicos-e-cursos/section-servicos-e-cursos.component';
import { SectionTituloCulturaColaborativaComponent } from './views/page-cultura-colaborativa/section-titulo-cultura-colaborativa/section-titulo-cultura-colaborativa.component';
import { PageEducacaoTecnologicaComponent } from './views/page-educacao-tecnologica/page-educacao-tecnologica.component';
import { SectionAlunoAEmpresarioComponent } from './views/page-educacao-tecnologica/section-aluno-a-empresario/section-aluno-a-empresario.component';
import { SectionInscricoesAbertasComponent } from './views/page-educacao-tecnologica/section-inscricoes-abertas/section-inscricoes-abertas.component';
import { SectionProjetoEducereComponent } from './views/page-educacao-tecnologica/section-projeto-educere/section-projeto-educere.component';
import { SectionTituloEducacaoTecnologicaComponent } from './views/page-educacao-tecnologica/section-titulo-educacao-tecnologica/section-titulo-educacao-tecnologica.component';
import { PageEmpreendedorismoInovacaoComponent } from './views/page-empreendedorismo-inovacao/page-empreendedorismo-inovacao.component';
import { SectionCaixaNumerosComponent } from './views/page-empreendedorismo-inovacao/section-caixa-numeros/section-caixa-numeros.component';
import { SectionEditalAbertoComponent } from './views/page-empreendedorismo-inovacao/section-edital-aberto/section-edital-aberto.component';
import { SectionEtapasInovacaoComponent } from './views/page-empreendedorismo-inovacao/section-etapas-inovacao/section-etapas-inovacao.component';
import { SectionFasesComponent } from './views/page-empreendedorismo-inovacao/section-fases/section-fases.component';
import { SectionNossosMentoresComponent } from './views/page-empreendedorismo-inovacao/section-nossos-mentores/section-nossos-mentores.component';
import { SectionDiretoriaExecutiva } from './views/section-diretoria-executiva/section-diretoria-executiva.component';
import { SectionQueroIncubarComponent } from './views/page-empreendedorismo-inovacao/section-quero-incubar/section-quero-incubar.component';
import { SectionTituloEmpreendedorismoInovacaoComponent } from './views/page-empreendedorismo-inovacao/section-titulo-empreendedorismo-inovacao/section-titulo-empreendedorismo-inovacao.component';
import { PageHomeComponent } from './views/page-home/page-home.component';
import { SectionBannerComponent } from './views/page-home/section-banner/section-banner.component';
import { SectionPreviaIncubadoraComponent } from './views/page-home/section-previa-incubadora/section-previa-incubadora.component';
import { SectionPreviaProjetoComponent } from './views/page-home/section-previa-projeto/section-previa-projeto.component';
import { PageNotFoundComponent } from './views/page-not-found/page-not-found.component';
import { PageSobreComponent } from './views/page-sobre/page-sobre.component';
import { SectionInstitucionalComponent } from './views/page-sobre/section-institucional/section-institucional.component';
import { SectionNumerosGraduadasComponent } from './views/page-home/section-numeros-graduadas/section-numeros-graduadas.component';
import { SectionTimelineComponent } from './views/page-sobre/section-timeline/section-timeline.component';
import { SectionTituloSobreComponent } from './views/page-sobre/section-titulo-sobre/section-titulo-sobre.component';

import { ApoioCulturalComponent } from './views/page-apoio-cultural/apoio-cultural/apoio-cultural.component';
import { EditalComponent } from './views/page-como-incubar-sua-empresa/edital/edital.component';
import { SectionArquivosComponent } from './views/page-como-incubar-sua-empresa/section-arquivos/section-arquivos.component';
import { SectionTituloIncubarComponent } from './views/page-como-incubar-sua-empresa/section-titulo-incubar/section-titulo-incubar.component';
@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    PageHomeComponent,
    PageLayoutComponent,
    PageSobreComponent,
    TopNavComponent,
    FooterComponent,
    SectionBannerComponent,
    SectionPilaresComponent,
    SectionPreviaIncubadoraComponent,
    SectionPreviaProjetoComponent,
    SectionEmpresasComponent,
    SectionTituloSobreComponent,
    SectionInstitucionalComponent,
    SectionNumerosGraduadasComponent,
    SectionTimelineComponent,
    PageAtuacaoComponent,
    SectionTituloAtuacaoComponent,
    SectionFocosAtuacaoComponent,
    PageContatoComponent,
    SectionFaleConoscoComponent,
    SectionMapaComponent,
    PageEducacaoTecnologicaComponent,
    PageEmpreendedorismoInovacaoComponent,
    PageCulturaColaborativaComponent,
    SectionTituloCulturaColaborativaComponent,
    SectionRedeColaboradoresComponent,
    SectionTituloEducacaoTecnologicaComponent,
    SectionDescricaoCulturaColaborativaComponent,
    SectionTituloEmpreendedorismoInovacaoComponent,
    SectionEditalAbertoComponent,
    SectionEtapasInovacaoComponent,
    SectionFasesComponent,
    SectionServicosECursosComponent,
    SectionProjetoEducereComponent,
    SectionCaixaNumerosComponent,
    SectionAlunoAEmpresarioComponent,
    SectionNossosMentoresComponent,
    SectionDiretoriaExecutiva,
    SectionQueroIncubarComponent,
    SectionInscricoesAbertasComponent,
    PageApoioCulturalComponent,
    SectionTituloApoioCulturalComponent,
    PageComoIncubarSuaEmpresaComponent,
    SectionIncubeSuaEmpresaComponent,
    EditalComponent,
    SectionArquivosComponent,
    SectionTituloIncubarComponent,
    ApoioCulturalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,

  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
